export default __webpack_public_path__ + "61addeae9dd96b7d5f2716a37047b663.woff";